import Image from "next/image";

const EngagementSectionMidContent = () => {
  return (
    <div className="flex flex-col-reverse md:grid md:grid-cols-12 md:gap-x-4 lg:gap-x-8">
      <div className="mt-6 md:mt-0 md:col-span-7 lg:col-span-6 flex flex-col justify-center items-center md:items-end space-y-6">
        <span className="mobile-h3 md:max-w-[480px] md:h4 lg:h3 text-center md:text-left">
          Optimize Your Market Opportunities
        </span>
        <span className="p-6 lg:max-w-[480px] border border-1 border-white/50 bg-black/20 rounded-lg shadow-2xl backdrop-blur-xl">
          Interested in the SimpleWaste preferred vendor program? New
          opportunities are available every week and in your markets.
        </span>
      </div>
      <div className="md:col-span-5 lg:col-span-6 flex justify-center items-center">
        <div>
          <Image
            src="/images/haulers/engagement-03.png"
            alt="Market Details"
            width={560}
            height={313}
          />
        </div>
      </div>
    </div>
  );
};

export default EngagementSectionMidContent;
